import { namespace } from 'vuex-class';
import { ILoadGlobalResourcesFilter } from '../types/load-resources-filter';
import { ITemplateGalleryState } from '../types/template-gallery-state';
import { ESortOrder } from '@/contract-management/contracts-table/types/enums/sort-order';
import { EResourceSortAttribute } from '@/api/resources/types/enum/resource-sort-attribute';

export const TemplateGallery = namespace('templateGallery');

export const state: ITemplateGalleryState = {
  loading: false,
  loaded: false,
  templates: [],
  documentId: null,
  newTemplateId: null,
};

export const defaultFilter: ILoadGlobalResourcesFilter = {
  searchTerms: [],
  limit: 30,
  offset: 0,
  sortBy: EResourceSortAttribute.CreatedAt,
  sortOrder: ESortOrder.Desc,
};

export enum ETemplateGalleryAction {
  LoadGlobalResources = 'loadGlobalResources',
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  SendOut = 'sendOut',
  SendOutSuccess = 'sendOutSuccess',
  SendOutFailed = 'sendOutFailed',
  Copy = 'copy',
  CopySuccess = 'copySuccess',
  CopyFailed = 'copyFailed',
}

export enum ETemplateGalleryMutation {
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetTemplates = 'setTemplates',
  SetDocumentId = 'setDocumentId',
  SetNewTemplateId = 'setNewTemplateId',
}
